/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface MeasurementUnitSummary {
  /** Full name of the measurement unit */
  display: string;
  /** Short display name or symbol for the measurement unit */
  displayShort: string;
}
